<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>

    <div class="topbar-end">
        <ul class="topbar-menu">

            <li class="ml-3" *ngIf="canVerIA">
                <button pButton type="button" label="IA" icon="pi pi-sparkles"
                        class="p-button-rounded flex-shrink-0 ia-button"
                        style="background:#7c3aed;border-color:#7c3aed;color:#fff;"
                        (click)="iaMenu.toggle($event)"></button>
                <p-menu #iaMenu [popup]="true" [model]="iaItems" appendTo="body"></p-menu>
            </li>
            <li class="ml-3">
                <button pButton type="button" icon="pi pi-cog" class="p-button-text p-button-secondary p-button-rounded flex-shrink-0" (click)="onConfigButtonClick()"></button>
            </li>
            <li class="topbar-profile">
                <button type="button" class="p-link" (click)="onProfileButtonClick()">
                    <img src="assets/layout/images/icon.png" alt="Profile" />
                </button>
            </li>
        </ul>
    </div>
</div>